<template>
  <div v-if="cart.products != null" class="app-container">
      <div v-for="item in cart.products" :key="item.id + '-' + item.productModifiers.map(m => m.choices.map(mo => mo.name))"
      class="cart-menuItem" :data-sku="item.sku">
        <div v-if="item.imageURL" class="img-container">
          <img :src="item.imageURL">
        </div>
        <div v-else class="img"></div>
        <h5>{{item.name}}</h5>
        <small>{{item.productModifiers.map(m => m.choices.map(mo => mo.name)).join(", ")}}</small>
        <h6 class="product-price" :data-price="item.price" :data-tax="item.tax">{{item.total.toFixed(2)}}</h6>
        <form>
            <div class="value-button-left updateQuantity" id="decrease" data-diff="-1" value="Decrease Value" :style="{ 'background-color': accentColor }">-</div>
            <input type="number" id="number" :data-sku="item.sku" :data-quantity="item.quantity" :value="item.quantity" />
            <div class="value-button-right updateQuantity" id="increase" data-diff="1" value="Increase Value" :style="{ 'background-color': accentColor }">+</div>
        </form>
      </div>

      <div class="cart-menuItem-total">
          <div class="cart-total-excluding-tax">
              Subtotal: <span>{{cart.totalExcludingTax.toFixed(2)}}</span>
          </div>
          <br>
          <div class="cart-total-tax">
              Tax: <span>{{cart.totalTax.toFixed(2)}}</span>
          </div>
          <br>
          <div class="cart-total">
              <span>{{cart.total.toFixed(2)}}</span>
          </div>
          <br><br>
          <button class="btn checkout" :style="{ 'background-color': accentColor }">
              Checkout&nbsp;<i class="fa fa-arrow-right"></i>
          </button>
          <br><br><br>
      </div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Cart.vue.js";

export default {
  name: "Home",
  components: {
  },
  mixins: [view],
  data() {
    return {
      cart: {}
    }
  },
  computed: {
      accentColor: function () {
        return this.$franchiseAccentColor;
      }
  },
  created() {
  },
  mounted() {
    var _self = this;
    var data = {
        FranchiseID: localStorage.franchiseID,
        GUID: localStorage.cartGuid
    }
    _self.$ooApi.orders.cart.v1(data).then(function (result) {
        _self.cart = result.data;
    }).then(function(){
      document.querySelectorAll('.cart-menuItem .updateQuantity').forEach(item => {item.addEventListener("click", _self.updateQuantityInput);});
      document.querySelectorAll('.cart-menuItem input#number').forEach(item => {item.addEventListener("change", _self.updateQuantity);});
      document.querySelector('.checkout').addEventListener("click", _self.checkout);
    });
  }
};
</script>
<style scoped>
    @import './Cart.vue.css'; 
</style>
